import { MainSlider } from "component/MainSlider";
import { InnerBanner } from "container/InnerpageBanner";
import { Crumbs } from "molecules/Breadcrumbs";
import { DetailBox } from "molecules/DetailBox";
import { TitleHeading } from "molecules/TitleHeading";
import { TestimonialSection } from "pages/communityImpact/testimonial";
import React from "react";
import ItemSlider from "./itemSlider";
import { SectionBorder } from "molecules/SectionBorder";
import { SmallHadding } from "molecules/SmallHeadding";
import { ArrowButton } from "molecules/ArrowButton";
import Tabs from "./Tabs";
import Divider from "molecules/SimpleBorder/Divider";

export const InsightsDetails2 = () => {
  return (
    <div className="backgroundThm mobileContainer">

      <section className="">
        <div className="container p-0 pl-0">
          <div className="container p-0 ">
        <Crumbs />
        </div>
          <div className="grid ">
            <div className="lg:col-12 md:col-12 sm:col-12 pl-0">
              <div className="grid align-items-center insight-detail-Head">
                <div className="lg:col-8 md:col-7 sm:col-12 pl-0 mt-2 ">
                  <TitleHeading
                    title="Portfolio Allocation Views"
                    className="m-0"
                  />
                </div>
                <div className="lg:col-4 md:col-5 sm:col-12 text-right">
                  <p className="my-0">Auguest 09,24</p>
                </div>
              </div>
            </div>
            <div className="lg:col-12 md:col-12 sm:col-12 pl-0">
              <img
                src="media/home_slider/blog-1-400x248 1 (4).png"
                alt=""
                // style={{ height: "628px" }}
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>

      <div className="container px-0">
      <section className="section-padding pb-0 px-0">
        <div className="container  pl-0 pr-0">
          <div className="grid">
            <div className="lg:col-4 md:col-5 sm:col-12 pl-1">
              <h3 className="font-normal" style={{fontSize:'14px'}}>Share</h3>
              <ul className="listing line">
                <li>
                  <a
                    href="http://"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black-alpha-90 p-0"
                  >
                    <i className="pi pi-facebook  text-2xl"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="http://"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black-alpha-90 "
                  >
                    <i className="pi pi-envelope text-2xl"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="http://"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black-alpha-90"
                  >
                    <i className="pi pi-twitter  text-2xl"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="http://"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black-alpha-90  "
                  >
                    <i className="pi pi-link text-2xl"></i>
                  </a>
                </li>
              </ul>
              <div className="author-box mt-2">
                <h4 className="mb-1" style={{fontSize:'14px'}}>Author</h4>
                <h5 className="my-1 text-red-600">Paras Pandit</h5>
              </div>
            </div>
            <div className="lg:col-8 md:col-7 sm:col-12  pr-0  pl-0 ">
              <div className="grid">
                <div className="lg:col-12 md:col-12 sm:col-12 pl-0 pr-0 width75">
                  <DetailBox className="fontEb font19" details="Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb the professional standards of the Indian realty sector by" />
                </div>
                <div className="my-3 
              width75
                 mr-0 py-2 border-black-200 flex">
                  <div
                    style={{ backgroundColor: "#4E6766" }}
                    className="w-full"
                  >
                    <div className="grid p-5 align-items-center  mr-0">
                      <div className="lg:col-12 md:col-12 sm:col-12 text-white pl-0 pr-0">
                        <SmallHadding
                          text="Hybrid Value"
                          className="mb-4 text-5xl eb-garamond-font"
                        />
                      </div>
                      <DetailBox
                        details=" Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the Ind...
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the Ind...Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the Ind..."
                        className="text-white fs-30"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Tabs />
            </div>
            

           
          </div>
        </div>
        <div className="container pl-0 pr-0">
        {/* <SectionBorder /> */}
        <Divider/>
      </div>
      </section>
     
      </div>
     
     <div className="container px-0">
      <section className="section-padding pb-4 px-0">
        <div className="container pb-2 pr-0 pl-0">
          <div className="gird">
            <div className="lg:col-12 md:col-12 sm:col-12 pl-0 py-0">
            <TitleHeading title="Explore More" className="mt-0 mb-3 font27 fontAva noLineHeight" />
            </div>
          </div>
          <ItemSlider />
        </div>
      </section>
      </div>
    </div>
  );
};
